import gql from 'graphql-tag';

const mmrCheckQuery = gql`
  query mmrCheckQuery($vin: String!) {
    mmrCheck(vin: $vin) {
      mmrValue
    }
  }
`;

export default mmrCheckQuery;
